import React from 'react'

type BadgeProps = {
  title: string
  icon: any
}

const Badge: React.FC<BadgeProps> = ({ title, icon }) => {
  const Icon = icon
  return (
    <div className="bg-foreground text-background px-4 py-1 rounded-full w-fit flex gap-2 items-center">
      <Icon className="w-4 h-4 fill-background" />
      <span className="text-sm text-background">{title}</span>
    </div>
  )
}

export default Badge
